<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    大学城站<br>
站点介绍<br>
大学城站位于南山区西丽镇留仙大道与丽山路丁字路口、留仙大道南侧主道，呈东西向布置。西北角为众冠时代广场，南侧为红花岭工业南区。稍远处便是风景迷人的塘朗山和错落有致的大学园区。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:12	23:45	5号线	3分钟	5分25秒<br>
黄贝岭	06:21	23:36	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:02	23:45	5号线	4分钟	6分钟<br>
黄贝岭	06:30	23:36	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:02	00:45	5号线	4分钟	6分钟<br>
黄贝岭	06:30	00:36	5号线	4分钟	6分钟<br><br>

站点出口信息<br><br>
B出入口:<br>
留仙大道南侧、红花北路北侧、深圳大学城创业园（B区）、众冠红花岭工业南区<br><br>
C出入口:<br>
丽山路东侧、留仙大道北侧（东）、平山村、哈尔滨工业大学（深圳）、深圳博林天瑞喜来登酒店<br><br>
D出入口:<br>
留仙大道北侧（西）、丽山路西侧、益田•假日里购物中心<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 红花岭站（东行）<br>
M385、M459、M554、74、81、M217、M299、M343<br><br>
C出入口:<br>
公交站名： 丽山路南站（北行）<br>
36、43、49、37、104<br><br>
D出入口:<br>
公交站名： 红花岭站(西行)<br>
M217、M299、M343、M385、M459、43、74、81、122、M554、37、104<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


